// Rollbar is initialised by the standalone script in public/index.html (loaded
// before the app bundle, so it can also report bundle load failures). Uncaught
// errors and unhandled rejections are captured by Rollbar itself; this module
// only exposes the instance for explicit reporting.
const noop = () => {};

const rollbar = window.Rollbar || {
  error: noop,
  warning: noop,
  info: noop,
  configure: noop,
};

export default rollbar;
